import { ReactNode, useRef } from 'react';
import { Transition } from 'react-transition-group';

interface Props {
  children: ReactNode;
  defaultMaxHeight?: number;
  isExpanded: boolean;
}

const Expand = ({ children, defaultMaxHeight, isExpanded }: Props) => {
  const nodeRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleEnter = () => {
    if (defaultMaxHeight) {
      nodeRef.current.style.maxHeight = `${defaultMaxHeight}px`;
    } else {
      nodeRef.current.style.height = '0px';
    }
  };

  const handleEntered = () => {
    if (defaultMaxHeight) {
      nodeRef.current.style.maxHeight = 'auto';
    } else {
      nodeRef.current.style.height = 'auto';
    }
  };

  const handleEntering = () => {
    if (defaultMaxHeight) {
      nodeRef.current.style.maxHeight = `${wrapperRef.current.clientHeight}px`;
    } else {
      nodeRef.current.style.height = `${wrapperRef.current.clientHeight}px`;
    }
  };

  const handleExit = () => {
    if (defaultMaxHeight) {
      nodeRef.current.style.maxHeight = `${wrapperRef.current.clientHeight}px`;
    } else {
      nodeRef.current.style.height = `${wrapperRef.current.clientHeight}px`;
    }
    // nodeRef.current.style.height = `${wrapperRef.current.clientHeight}px`;
    nodeRef.current.offsetHeight; // hack to trigger browser reflow
  };

  const handleExiting = () => {
    if (defaultMaxHeight) {
      nodeRef.current.style.maxHeight = `${defaultMaxHeight}px`;
    } else {
      nodeRef.current.style.height = '0px';
    }
  };

  return (
    <Transition
      in={isExpanded}
      nodeRef={nodeRef}
      onEnter={handleEnter}
      onEntered={handleEntered}
      onEntering={handleEntering}
      onExit={handleExit}
      onExiting={handleExiting}
      timeout={300}
    >
      {(state) => (
        <div
          className={`expand ${
            defaultMaxHeight ? 'expand-with-max-height' : 'expand-default'
          } ${state}`}
          ref={nodeRef}
        >
          <div className="wrapper" ref={wrapperRef}>
            <div className="inner">{children}</div>
          </div>

          <style jsx>{`
            .expand {
              min-height: 0;
              overflow: hidden;
              transition: height 300ms, max-height 300ms;
            }
            .expand-default {
              height: 0;
            }
            .expand-with-max-height {
              max-height: ${defaultMaxHeight}px;
            }
            .entered {
              height: auto;
              overflow: visible;
            }
            .exited {
              visibility: ${defaultMaxHeight ? 'visible' : 'hidden'};
            }
            .wrapper {
              display: flex;
            }
            .inner {
              width: 100%;
            }
          `}</style>
        </div>
      )}
    </Transition>
  );
};

export default Expand;
